import { render, staticRenderFns } from "./SecondAsidePanel.vue?vue&type=template&id=6a1f26a4&scoped=true"
import script from "./SecondAsidePanel.vue?vue&type=script&lang=js"
export * from "./SecondAsidePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1f26a4",
  null
  
)

export default component.exports